<template>
  <div>
    <div class="sa-col-xs12 sa-col-sm6 sa-col-md7 sa-col-lg7"></div>
    <div class="sa-form-group" >
      <input :disabled="!pflag"  ref="autocomplete" name="map" id="map" placeholder="search" class="sa-form-control" :class="!pflag?'sa-disabled':''"  v-model="location"
        type="text" />
    </div>
    
  </div>
</template>
<script>
  export default {
    props:['lats','long','locname','pflag'],
    data() {
      return {
        bound: null,
        lat: 0,
        lon: 0,
        location:""
      }
    },
    computed: {
      mapLati() {
        return this.lats
      },
      mapLong() {
        return this.long
      }
    },
    methods: {
      _renderMap: function (lat, lon) {
        this.$emit("getlocation", lat, lon);
        let _self = this
        
        let map = new google.maps.Map(document.getElementById('sanar-map'), {
          center: {
            lat: lat,
            lng: lon
          },
          zoom: 15
        });
        map.addListener('tilesloaded', function () {
          new google.maps.Marker({
            position: {
              lat: lat,
              lng: lon
            },
            map: map
          });
          map.panBy(-90, 0)
        })
      },
      _renderplace: function (place) {
        this.$emit("getplace", place);
      }
    },
    mounted() {
      let _self = this
      _self.autocomplete = new google.maps.places.Autocomplete(
        (_self.$refs.autocomplete), {}
      );
      _self.autocomplete.addListener('place_changed', () => {
        let place = _self.autocomplete.getPlace();
        let lat = place.geometry.location.lat();
        let lon = place.geometry.location.lng();
        _self.lat = parseFloat(lat)
        _self.lon = parseFloat(lon)
        // _self._renderMap(lat, lon)
        _self._renderplace(place)
      });
       _self.location=_self.locname
    },
    watch: {
        locname: function (val) {
            this.location = val
    }
  },
  }
</script>